/** Uebergabe eines Hundes an einen Kaeufer - Sicht des Zuechters (siehe DogTransferDto im Backend). */
export interface DogTransferItem {
  id: number;
  status: 'pending' | 'completed' | 'cancelled' | 'expired';
  /** Nur bei offenen Uebergaben. */
  code: string | null;
  /** Nach dem Abschluss null - der Hund gehoert dann dem Kaeufer. */
  dogId: number | null;
  dogName: string;
  breedNameGerman: string | null;
  breedNameEnglish: string | null;
  sex: string;
  dateOfBirth: string | null;
  microchipNumber: string | null;
  collarColor: string | null;
  breedingPlanId: number | null;
  note: string | null;
  toUserName: string | null;
  createdAt: string;
  expiresAt: string;
  completedAt: string | null;
  cancelledAt: string | null;
}

export const breedNameFor = (item: { breedNameGerman: string | null; breedNameEnglish: string | null }, language: string): string | null =>
  (language.startsWith('de') ? item.breedNameGerman : item.breedNameEnglish ?? item.breedNameGerman) ?? item.breedNameGerman;
